import axios from "axios";
import { createMutationRequestHook } from "shared/hooks/createMutationRequestHook";
import getLocalApiUrl from "pages/reports/utils/getLocalApiUrl";

export interface SendEmailReportRequest {
  reportId: number;
  sendTo: string[];
  body: string;
  timezone?: string;
}

export interface SendEmailReportResponse {
  success: boolean;
  message: string;
}

const sendEmailReport = async (
  request: SendEmailReportRequest,
): Promise<SendEmailReportResponse> => {
  const requestWithTimezone = {
    ...request,
    timezone:
      request.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
  };

  const response = await axios.post<SendEmailReportResponse>(
    getLocalApiUrl("/reporting/email-schedules/send-email"),
    requestWithTimezone,
  );
  return response.data;
};

export const useSendEmailReport = createMutationRequestHook<
  SendEmailReportResponse,
  Error,
  SendEmailReportRequest
>({
  fetch: sendEmailReport,
});
